import React, { useState } from 'react'
import { Dialog, Switch, DialogContent, Grid, TextField, DialogActions, Button, DialogTitle, Typography, CircularProgress } from '@material-ui/core'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Formik } from 'formik'

import * as goalTypesDUCK from "../../../../redux/ducks/goal_types.duck"
import { setLoader } from '../../../../redux/ducks/load.duck'
import { saveGoalType, updateGoalType } from '../../../crud/api/goal_types.crud'

const GoalsDialog = ({ mode, setDialog, zone, goal_type, goalsActions, settingLoader }) => {
  const open = mode === 'editing' || mode === 'create'
  const title = mode === 'editing' ? "Edit Goal" : "New Goal"
  const [loading, setLoading] = useState(false);

  const create = async values => {
    let zone_id = zone === "mind" ? 1 : zone === "body" ? 2 : 3

    const newGoal = {
      ...values,
      student_zone_id: zone_id
    }
    try {
      await saveGoalType(goalsActions.updateGoalTypes, newGoal)
      setDialog("close")
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  
  const update = async values => {
    const newGoal = {
      ...values,
      student_zone_id: goal_type.student_zone.id
    }
    try {
      await updateGoalType(goalsActions.updateGoalTypes, newGoal, goal_type.id)
      setDialog("close")
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  return (
    <Dialog open={open} onClose={() => setDialog("close")} id="goal_dialog">
      <Formik
        initialValues={{
          ...goal_type
        }}
        validate={values => {
          const errors = {}
          if (!values.name) errors.name = 'Required field'

          return errors
        }}
        onSubmit={(values, { setSubmitting }) => {
          setLoading(true)
          settingLoader(true)
          setTimeout(() => {
            goal_type.id ? update(values) : create(values)
            setSubmitting(false)
          }, 1000)
        }}>
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, isSubmitting }) => (
        <form noValidate={true} autoComplete='off' onSubmit={handleSubmit}>
          <DialogTitle disableTypography className="dialog-title">
            <Typography variant="h6">
              {title}
            </Typography>
            <Switch
              name="active"
              id="goal_active_input_dialog"
              checked={values.active}
              onBlur={handleBlur}
              onChange={handleChange}
            />
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={10}>
                <TextField
                  required
                  fullWidth
                  variant="outlined"
                  id="goal_name_input_dialog"
                  label="Name"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={touched.name && errors.name}
                  error={Boolean(touched.name && errors.name)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  rowsMax="4"
                  variant="outlined"
                  id="goal_description_input_dialog"
                  label="Description"
                  name="description"
                  value={values.description}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button id="cancel_goal_dialog" onClick={() => setDialog("close")} color="secondary">
              Cancel
            </Button>
            <button
              type="submit"
              id="submit_goal_dialog"
              disabled={isSubmitting || !values.name}
              className="btn btn-primary btn-elevate kt-login__btn-primary d-flex">
              {mode === "editing" ? "Submit" : "Create"}
              {loading && <CircularProgress color="inherit" size={18} style={{ marginLeft: 10 }} />}
            </button>
          </DialogActions>
        </form>
      )}
      </Formik>
    </Dialog>
  )
}

const mapStateToProps = store => ({
  goal_type: store.goal_t.goal_type,
})

const mapDispatchToProps = (dispatch) => ({
  goalsActions: bindActionCreators(goalTypesDUCK.actions, dispatch),
  settingLoader: bindActionCreators(setLoader, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(GoalsDialog)
